import { Component as TsxComponent } from 'vue-tsx-support/lib/api';
import {
  BaseButtonProps,
  ButtonColor, ButtonKind, BUTTON_COLOR_MAP, BUTTON_KIND_MAP, BUTTON_SIZE_MAP,
} from 'components/form/base-button/types';
import { Component, Prop } from 'vue-property-decorator';
import { ButtonHTMLAttributes, EventsOn, SyntheticEvent } from 'vue-tsx-support/types/dom';
import { Size } from 'components/types';
import { Location } from 'vue-router';
import styles from './base-button.css';

export interface Props extends BaseButtonProps {
  to: string | Location;
}

interface Events {
  onClick: (e: SyntheticEvent<HTMLButtonElement, MouseEvent>) => void;
}

@Component({
  inheritAttrs: false,
})
export default class BaseLink extends TsxComponent<
ButtonHTMLAttributes & Props, Events & Omit<EventsOn<HTMLButtonElement>, 'onClick'>
> {
  @Prop({ default: ButtonColor.PRIMARY })
  public color: NonNullable<Props['color']>;

  @Prop({ default: ButtonKind.FILL })
  public kind: NonNullable<Props['kind']>;

  @Prop({ default: Size.MEDIUM })
  public size: NonNullable<Props['size']>;

  @Prop()
  public to: Props['to'];

  public render() {
    return (
      <router-link
        to={this.to}
        {...{
          attrs: this.$attrs,
          on: { ...this.$listeners },
        }}
        class={[
          styles.button,
          BUTTON_SIZE_MAP[this.size],
          BUTTON_KIND_MAP[this.kind],
          BUTTON_COLOR_MAP[this.color],
        ]}
      >
        {this.$slots.default}
      </router-link>
    );
  }
}
